import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { theme } from '@garnish/constants';
import type { CollectionCardProps } from '../../CollectionCard';
import { CollectionCard, CollectionCardLoading } from '../../CollectionCard';

// ────────────────────────────────────────────────────────────────────

export const CollectionsRailItem = (props: CollectionRailItemProps) => {
  const { collection, isLoading, width, gap, onPress } = props;
  const {
    id = '',
    title = '',
    description = '',
    imageUrl = '',
    testID,
  } = collection ?? {};

  const dynamicStyles = useStyle(
    () => ({ width, paddingRight: gap }),
    [width, gap],
  );
  const style = [styles.item, dynamicStyles];

  return (
    <View style={style} testID="collection-card">
      {isLoading ? (
        <CollectionCardLoading />
      ) : (
        <CollectionCard
          onPress={onPress}
          description={description}
          imageUrl={imageUrl}
          id={id}
          title={title}
          testID={testID}
        />
      )}
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  item: {
    paddingVertical: theme.spacing.xsmall,
  },
});

// ─── TYPES ─────────────────────────────────────────────────────────────────

type CollectionRailItemProps = {
  readonly width: number;
  readonly gap: number;
  readonly collection?: Omit<CollectionCardProps, 'onPress'>;
  readonly isLoading?: boolean;
  readonly onPress?: (collectionId: string) => void;
};
